import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vant from 'vant';
import 'vant/lib/index.css';
import './assets/css/bootstrap.min.css'
import './assets/css/base.css'
import './assets/js/rem.js'

Vue.config.productionTip = false

Vue.use(Vant);

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
